import { computed, unref } from 'vue'
import { storeToRefs } from 'pinia'
import { useBusinessStore } from '@/store'

const __DEV__ = process.env.NODE_ENV === 'development'

/**
 * 远程 config.json 的响应式引用 (来自 businessStore)
 *
 * 用法:
 *   const config = useConfig()
 *   <div v-html="config.tips" />
 *
 * 配合 ?? 做默认值兜底, 布尔开关用 useConfigFlag.
 *
 * @returns {import('vue').Ref<object>}
 */
export function useConfig() {
  const { config } = storeToRefs(useBusinessStore())
  return config
}

/**
 * 远程 config.json 布尔开关 + 本地开发兜底
 *   - dev (pnpm serve) 期始终返回 true, 绕过 config, 方便调试
 *   - prod 走真实字段, 字段未下发或为 false 都隐藏
 *
 * 用法:
 *   const showFullRuleBtn = useConfigFlag('season_rule_show')
 *   <ui-button v-if="showFullRuleBtn" ...>
 *
 * @param {string} key config 里的字段名
 * @param {{ devForce?: boolean }} [opts] devForce=false 关掉 dev 兜底, 本地也按真实字段走
 * @returns {import('vue').ComputedRef<boolean>}
 */
export function useConfigFlag(key, { devForce = true } = {}) {
  const config = useConfig()
  return computed(() => {
    if (__DEV__ && devForce) return true
    return Boolean(unref(config)?.[key])
  })
}
